import React, { useCallback, useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import IdentificacaoCrudCliente from './DadosCadastrais/Identificacao/IdentificacaoCrudCliente';
import SnackbarUI from '../../UI/Snackbar/Snackbar';
import { SNACKBAR_DURATION } from '../../../helpers/constants/global.constants';
import useUtilStyles from '../../../helpers/styles/utils.styles';
import {
  getAcompanhamentoClienteAction,
  getClienteByIdAction, getEmpresasGrupoAction,
  insertClienteAction, migrarPossivelClienteAction,
  updateClienteAction, enviarEmailRedefinirSenhaAction,
} from '../../../store/Cliente/V2/Crud/crudCliente.saga';
import {
  changeTabViewAction,
  openDialogAction,
  openMigrarFollowUpAction,
  openSnackbarAction,
  onChangeControls, onChangeActions, setRequestFieldsFocusAction,
} from '../../../store/Cliente/V2/Crud/crudCliente.store';

import { useCrudClienteDispatch, useCrudClienteSelector } from '../../../store/Cliente/V2/Crud/CrudClienteProvider';
import EnderecoCrudCliente from './DadosCadastrais/Endereco/EnderecoCrudCliente';
import TelefonesCrudCliente from './DadosCadastrais/Telefones/TelefonesCrudCliente';
import EmailCrudCliente from './DadosCadastrais/Emails/EmailsCrudCliente';
import DadosAdvogadoCrudCliente from './DadosCadastrais/DadosAdvogado/DadosAdvogadoCrudCliente';
import TabCardLayout from '../../../layouts/TabCardLayout/v2/TabCardLayout';
import FooterForm from '../../UI/FooterForm/FooterForm';
import TabPanel from '../../UI/TabPanel/TabPanel';
import TabModel from '../../../models/TabModel';
import { getCurrentIdUsuario, moveScroll, replaceTo } from '../../../helpers/utils/utils';
import CampoObrigatorio from '../../UI/CampoObrigatorio/CampoObrigatorio';
import UsuariosCrudCliente from './Tabs/Usuario/Usuarios/UsuariosCrudCliente';
import DadosComplementares from './Tabs/DadosComplementares/DadosComplementares';
import EmpresasGrupo from './Tabs/EmpresaGrupo/EmpresasGrupo';
import AlertDialog from '../../UI/Dialogs/AlertDialog/AlertDialog';
import AcompanhamentoCliente from './Acompanhamento/AcompanhamentoCliente';
import BaseDeCalculo from './Tabs/BaseCalculo/BaseCalculo';
import { MESSAGE_GREEN_LABEL, MESSAGE_MIGRAR_DIALOG, MESSAGE_RED_LABEL } from './crudCliente.constants';
import dicaIcon from '../../UI/Dica/lampada-icon.png';
import { DocumentosCliente } from './Tabs/Documentos/DocumentosCliente';
import PrestacaoContas from './Tabs/PrestacaoDeContas/PrestacaoContas';
import OptionDialogNew from '../../UI/Dialogs/OptionDialog/OptionDialogNew';
import Grid24 from '../../UI/Grid24';
import RadioField from '../../UI/Field/Radio/RadioField';
import { GroupDefinitions } from './Tabs/BaseCalculo/Honorarios/styles';
import FichaDoCliente from './Tabs/FichaDoCliente/FichaDoCliente';
import EstatisticasDoCliente from './Tabs/EstatisticasDoCliente/EstatisticasDoCliente';
import { getUsuarioCompletoPeloId } from '../../../services/core/usuario/usuario.services';

const tabItems = [
  new TabModel('tab-identificacao', 0, 'Identificação', 'scrollable-auto-tabpanel'),
  new TabModel('tab-endereco', 1, 'Endereço', 'scrollable-auto-tabpanel'),
  new TabModel('tab-telefone-emails', 2, 'Telefones e E-mails', 'scrollable-auto-tabpanel'),
  new TabModel('tab-gerenciamento-acessos', 3, 'Gerenciamento de Acessos', 'scrollable-auto-tabpanel'),
  new TabModel('tab-acompanhamento', 4, 'Acompanhamento', 'scrollable-auto-tabpanel'),
  new TabModel('tab-empresas-grupo', 5, 'Empresas do Grupo', 'scrollable-auto-tabpanel'),
  new TabModel('tab-base-calculo', 6, 'Base de Cálculo', 'scrollable-auto-tabpanel'),
  new TabModel('tab-documentos', 7, 'Documentos', 'scrollable-auto-tabpanel'),
  new TabModel('tab-prestacao-contas', 8, 'Prestação de Contas', 'scrollable-auto-tabpanel'),
  new TabModel('tab-dados-complementares', 9, 'Dados Complementares', 'scrollable-auto-tabpanel'),
  new TabModel('tab-estatisticas', 10, 'Estatísticas', 'scrollable-auto-tabpanel'),
  new TabModel('tab-ficha-cliente', 11, 'Ficha do Cliente', 'scrollable-auto-tabpanel'),
];

function CrudCliente({
  isCliente = true,
  isEditMode = false,
  isInsertMode = false,
  isInpectMode = false,
  isMigrar = false,
  match,
  history,
}) {
  const utilStyles = useUtilStyles();
  const dispatch = useCrudClienteDispatch();

  const snackbar = useCrudClienteSelector(states => states.actions.snackbar);
  const alertDialog = useCrudClienteSelector(states => states.actions.alertDialog);
  const activeTabView = useCrudClienteSelector(states => states.actions.tabActive);
  const hasNotAcompanhamentos = useCrudClienteSelector(states => states.settingsAcompanhamento.acompanhamentos.length === 0);
  const migrarFollowUpDialog = useCrudClienteSelector(states => states.actions.followUpMigrarDialogContent);
  const hasDataFu = useCrudClienteSelector(states => states.controls.dataFu.value !== '');
  const codEmpresaPrincipal = useCrudClienteSelector(states => states.controls.codEmpresaPrincipal.value);
  const logoCliente = useCrudClienteSelector(state => state.image);
  const exibirLogoProprioAS = useCrudClienteSelector(state => state.controls.exibirLogoProprioAS);
  const emails = useCrudClienteSelector(states => states.controls.emails);
  const idCliente = useCrudClienteSelector(states => states.controls.idCliente.value);
  const [onOpenRedefinirSenhaDialog, setOnOpenRedefinirSenhaDialog] = useState(false);
  const [definition, setDefinition] = useState('');
  const [emailsParaDialog, setEmailsParaDialog] = useState([]);
  const [idClienteParaEmail, setIdClienteParaEmail] = useState('');
  const [tipoUsuarioLogado, setTipoUsuarioLogado] = useState(null);

  const ehUsuarioComercial = tipoUsuarioLogado?.idTipoUsuario === 1;

  const focusFieldsHandler = useCallback((event) => {
    let fieldName = event.target.name;
    if (event.target.nextElementSibling) {
      fieldName = event.target.nextElementSibling.name;
    }
    dispatch(setRequestFieldsFocusAction(fieldName));
  }, [dispatch]);

  const roolBackHandler = useCallback(() => (isCliente
    ? replaceTo(history, '/cliente')
    : replaceTo(history, '/possivel-cliente')), [history, isCliente]);

  const closeErrorDialogHandler = () => {
    dispatch(openDialogAction(false));
    if (alertDialog.origin === 'CLIENTE_NOT_FOUND') {
      roolBackHandler();
    }
  };

  const closeSnackbarHandler = () => {
    dispatch(openSnackbarAction({ open: false }));
  };

  const onMigrarPossivelCliente = useCallback(() => {
    dispatch(migrarPossivelClienteAction(roolBackHandler));
  }, [dispatch, roolBackHandler]);

  const verificaDataFollowUp = useCallback((hasDataFollowUp) => {
    if (hasDataFollowUp) {
      dispatch(openMigrarFollowUpAction({
        open: true,
        message: MESSAGE_MIGRAR_DIALOG,
        greenLabel: MESSAGE_GREEN_LABEL,
        redLabel: MESSAGE_RED_LABEL,
      }));
    } else {
      onMigrarPossivelCliente();
    }
  }, [dispatch, onMigrarPossivelCliente]);

  const enviarEmailRedefinirSenha = useCallback(() => {
    if (!definition) {
      toast.error('Nenhum email selecionado para envio.');
      return;
    }

    // Usa o idClienteParaEmail que é atualizado pelo useEffect
    const clienteId = idClienteParaEmail || idCliente;

    if (!clienteId) {
      toast.error('ID do cliente não encontrado. Certifique-se de que o cliente foi salvo corretamente.');
      return;
    }

    // Usa os emails armazenados se disponíveis, senão usa os emails do estado
    const emailsParaVerificar = emailsParaDialog.length > 0 ? emailsParaDialog : emails;
    const emailSelecionado = emailsParaVerificar.find(e => e.email.value === definition);

    if (emailSelecionado) {
      const payload = {
        email: emailSelecionado.email.value,
        codigo: clienteId.toString(),
        origem: 'PORTAL_CLIENTE',
      };
      dispatch(enviarEmailRedefinirSenhaAction(payload));
    }
  }, [dispatch, emails, emailsParaDialog, definition, idCliente, idClienteParaEmail]);

  const salvarCliente = useCallback((showEmailDialogAfterSuccess = false) => {
    const foto = logoCliente.file ? logoCliente.file : null;
    const hasPreviewUrl = logoCliente.imagePreviewUrl ? logoCliente.imagePreviewUrl : null;

    // Callback para mostrar o dialog após sucesso do salvamento
    const successCallback = showEmailDialogAfterSuccess ? () => {
      // Aguarda um pouco para o Redux atualizar o estado
      setTimeout(() => {
        setOnOpenRedefinirSenhaDialog(true);
      }, 100);
    } : null;

    if (isInsertMode) {
      if (!hasPreviewUrl && exibirLogoProprioAS.value) {
        dispatch(onChangeActions('errorImage', true));
        toast.error('Logo obrigatório',
          { style: { width: '392px' } });
      } else {
        dispatch(insertClienteAction(isCliente, foto, successCallback));
      }
    }

    if (isEditMode && !isMigrar) {
      if (!hasPreviewUrl && exibirLogoProprioAS.value) {
        dispatch(onChangeActions('errorImage', true));
        toast.error('Logo obrigatório',
          { style: { width: '392px' } });
      } else {
        dispatch(updateClienteAction(isCliente, roolBackHandler, foto));
        // Para modo de edição, executar callback imediatamente se fornecido
        if (successCallback) {
          successCallback();
        }
      }
    }

    if (isMigrar) {
      verificaDataFollowUp(hasDataFu);
    }
  }, [dispatch, isInsertMode, isEditMode, isMigrar, isCliente, logoCliente, exibirLogoProprioAS, hasDataFu, verificaDataFollowUp, roolBackHandler, setOnOpenRedefinirSenhaDialog]);

  const salvarClienteEEnviarEmail = useCallback(() => {
    // Como o cliente já foi salvo anteriormente, apenas envia o email
    enviarEmailRedefinirSenha();
  }, [enviarEmailRedefinirSenha]);

  const submitHandler = useCallback(() => {
    let existePadrao = false;
    const emailsComPadrao = [];

    emails.forEach((email) => {
      if (email.permitirPadrao.value) {
        existePadrao = true;
        emailsComPadrao.push(email);
      }
    });
    setDefinition(emailsComPadrao[0]?.email?.value);
    if (isInsertMode && existePadrao) {
      // Armazena os emails com padrão antes do salvamento
      setEmailsParaDialog(emailsComPadrao);
      // Para modo INSERT com emails padrão, salva o cliente primeiro
      // O dialog será mostrado após o sucesso do salvamento
      salvarCliente(true);
    } else {
      salvarCliente(false);
    }
  }, [salvarCliente, emails, isInsertMode]);

  const onChangeRadioHandler = useCallback((event) => {
    const { value } = event.target;
    setDefinition(value);
  }, []);

  function loadTabView(activeTab) {
    if (activeTab === 4 && hasNotAcompanhamentos && (isEditMode || isInpectMode)) {
      dispatch(getAcompanhamentoClienteAction(isCliente, true));
    }
    if (activeTab === 5 && (isEditMode || isInpectMode) && codEmpresaPrincipal !== '') {
      dispatch(getEmpresasGrupoAction(codEmpresaPrincipal, isCliente));
    }
  }

  const changeActiveTabeViewHandler = (activeTab) => {
    loadTabView(activeTab);
    dispatch(changeTabViewAction(activeTab));
  };

  useEffect(() => {
    async function loadUser() {
      const idUsuario = getCurrentIdUsuario();
      const response = await getUsuarioCompletoPeloId(idUsuario);
      setTipoUsuarioLogado(response.data);
    }
    loadUser();
  }, []);

  useEffect(() => {
    moveScroll();
    const hasClientId = match.params.id;
    if (!isInsertMode && hasClientId) {
      dispatch(getClienteByIdAction(isCliente, hasClientId));
    }
  }, [dispatch, match, isInsertMode, isCliente]);

  // Observa mudanças no idCliente e atualiza o estado local
  useEffect(() => {
    if (idCliente) {
      setIdClienteParaEmail(idCliente);
    }
  }, [idCliente]);

  const onClose = useCallback(() => {
    dispatch(openMigrarFollowUpAction({ open: false }));
  }, [dispatch]);

  const onClickGreen = useCallback(() => {
    onClose();
    onMigrarPossivelCliente();
  }, [onClose, onMigrarPossivelCliente]);

  const onClickRed = useCallback(() => {
    onClose();
    dispatch(onChangeControls('removerDataFollowUp', true));
    onMigrarPossivelCliente();
  }, [onClose, dispatch, onMigrarPossivelCliente]);

  function buildAlertDialogContent(variant) {
    if (variant === 'warning') {
      return (
        <>
          <Typography style={{ textAlign: 'center', fontWeight: 'bold', marginBottom: '10px' }} component="p">{alertDialog.message}</Typography>
          <Typography style={{ textAlign: 'center' }} component="p">
            <img src={dicaIcon} alt="Dica" width={18} height={18} />
            {' '}
            <b>Dica</b>
            : Abra o arquivo inválido em um editor de imagem e
            salve como uma nova imagem de formato válido (PNG, JPEG ou JPG).
            Retorne para o cadastro e tente selecionar a imagem novamente.
          </Typography>
        </>
      );
    }
    return <Typography style={{ textAlign: 'center' }} component="p">{alertDialog.message}</Typography>;
  }

  const pageForm = () => (
    <>
      <SnackbarUI
        open={snackbar.open}
        autoHideDuration={SNACKBAR_DURATION}
        variant={snackbar.variant}
        message={snackbar.message}
        onClose={closeSnackbarHandler}
      />
      <AlertDialog
        open={alertDialog.open}
        variant={alertDialog.variant}
        onClickConfirm={closeErrorDialogHandler}
      >
        {buildAlertDialogContent(alertDialog.variant)}
      </AlertDialog>
      <OptionDialogNew
        open={onOpenRedefinirSenhaDialog}
        disableConfirm={!definition}
        confirmLabel="Sim"
        cancelLabel="Não"
        onClickCancel={() => {
          setDefinition('');
          setEmailsParaDialog([]);
          setOnOpenRedefinirSenhaDialog(false);
          roolBackHandler();
        }}
        onClickConfirm={() => {
          setOnOpenRedefinirSenhaDialog(false);
          salvarClienteEEnviarEmail();
          setDefinition('');
          setEmailsParaDialog([]);
          roolBackHandler();
        }}
        text="Deseja enviar e-mail para o cliente definir a senha?"
      >
        <div style={{
          width: '480px', fontSize: '16px', textAlign: 'left',
        }}
        >
          <p>
            Confirme o e-mail para envio das instruções de redefinição de senha:
          </p>
          <div style={{ fontWeight: 'bold', fontSize: '16px' }}>
            <GroupDefinitions
              aria-label="email"
              value={definition}
              onChange={onChangeRadioHandler}
            >
              {(emailsParaDialog.length > 0 || emails.length > 0 ? emailsParaDialog : emails).map((email, index) => (
                email.permitirPadrao.value && (
                  <Grid24 xs={24} sm={24} key={index}>
                    <RadioField label={email.email.value} value={email.email.value} />
                  </Grid24>
                )
              ))}
            </GroupDefinitions>
          </div>
        </div>
      </OptionDialogNew>
      <OptionDialogNew
        open={migrarFollowUpDialog.open}
        confirmLabel="Confirmar"
        cancelLabel="Cancelar"
        onClickCancel={onClickRed}
        onClickConfirm={onClickGreen}
      >
        <div style={{ fontSize: '18px' }}>
          <p>
            {migrarFollowUpDialog.message}
          </p>
        </div>
      </OptionDialogNew>
    </>
  );

  const tabsForm = () => (
    <div className={utilStyles.mt16}>
      <CampoObrigatorio visible={isEditMode || isInsertMode} />
      <TabCardLayout
        tabItems={tabItems}
        parentStates={[activeTabView, changeActiveTabeViewHandler]}
        footerComponent={(
          <FooterForm
            hasRollback={isInpectMode}
            cancelHandler={roolBackHandler}
            submitHandler={submitHandler}
            rollbackHandler={roolBackHandler}
            isMigrarParaCliente={isMigrar}
          />
        )}
      >
        <TabPanel id={tabItems[0].id} index={tabItems[0].index} value={activeTabView} isDisabled={ehUsuarioComercial}>
          <IdentificacaoCrudCliente
            isEditMode={isEditMode || isInsertMode}
            match={match}
          />
          <DadosAdvogadoCrudCliente
            isEditMode={isEditMode || isInsertMode}
          />
        </TabPanel>
        <TabPanel id={tabItems[1].id} index={tabItems[1].index} value={activeTabView} isDisabled={ehUsuarioComercial}>
          <EnderecoCrudCliente
            isEditMode={isEditMode || isInsertMode}
          />
        </TabPanel>
        <TabPanel id={tabItems[2].id} index={tabItems[2].index} value={activeTabView} isDisabled={ehUsuarioComercial}>
          <TelefonesCrudCliente
            isEditMode={isEditMode || isInsertMode}
          />
          <EmailCrudCliente
            isEditMode={isEditMode || isInsertMode}
          />
        </TabPanel>
        <TabPanel id={tabItems[3].id} index={tabItems[3].index} value={activeTabView} isDisabled={ehUsuarioComercial}>
          <UsuariosCrudCliente
            isEditMode={isEditMode}
            isInsertMode={isInsertMode}
            showPassword={isEditMode || isInpectMode}
          />
        </TabPanel>
        <TabPanel id={tabItems[4].id} index={tabItems[4].index} value={activeTabView}>
          <AcompanhamentoCliente
            isInsertMode={isInsertMode}
            isEditMode={isEditMode}
            isQueryMode={isInpectMode}
            isCliente={isCliente}
            idCliente={match.params.id}
          />
        </TabPanel>
        <TabPanel id={tabItems[5].id} index={tabItems[5].index} value={activeTabView} isDisabled={ehUsuarioComercial}>
          <EmpresasGrupo
            isEditMode={isEditMode}
            isCliente={isCliente}
            isMigrarParaCliente={isMigrar}
          />
        </TabPanel>
        <TabPanel id={tabItems[6].id} index={tabItems[6].index} value={activeTabView} isDisabled={ehUsuarioComercial}>
          <BaseDeCalculo
            isEditMode={isEditMode || isInsertMode}
            isInsertMode={isInsertMode}
          />
        </TabPanel>
        <TabPanel id={tabItems[7].id} index={tabItems[7].index} value={activeTabView}>
          <DocumentosCliente
            idCliente={match.params.id}
            isEditMode={isEditMode}
            isInsertMode={isInsertMode}
            isComercialPrincipal={ehUsuarioComercial}
          />
        </TabPanel>
        <TabPanel id={tabItems[8].id} index={tabItems[8].index} value={activeTabView}>
          <PrestacaoContas
            isEditMode={isEditMode}
            isInsertMode={isInsertMode}
            onFocus={focusFieldsHandler}
            idCliente={match.params.id}
            isComercialPrincipal={ehUsuarioComercial}
          />
        </TabPanel>
        <TabPanel id={tabItems[9].id} index={tabItems[9].index} value={activeTabView} isDisabled={ehUsuarioComercial}>
          <DadosComplementares isEditMode={isEditMode || isInsertMode} />
        </TabPanel>
        <TabPanel id={tabItems[10].id} index={tabItems[10].index} value={activeTabView}>
          <EstatisticasDoCliente
            idCliente={match.params.id}
            isInsertMode={isInsertMode}
          />
        </TabPanel>
        <TabPanel id={tabItems[11].id} index={tabItems[11].index} value={activeTabView}>
          <FichaDoCliente
            idCliente={match.params.id}
            isInsertMode={isInsertMode}
          />
        </TabPanel>
      </TabCardLayout>
    </div>
  );

  return (
    <>
      {pageForm()}
      {tabsForm()}
    </>
  );
}

export default withRouter(CrudCliente);
